import { Injectable } from "@angular/core";
import { NgbDateAdapter, NgbDateStruct } from "@ng-bootstrap/ng-bootstrap";
const pad = (i: number): string => i < 10 ? `0${i}` : `${i}`;
/**
 * This handles how the date is represented in ngModel.
 */
 @Injectable()
 export class CustomAdapter extends NgbDateAdapter<string> {
   readonly DELIMITER = '-';
   fromModel(value: string | null): NgbDateStruct | null {
     if (value) {
       const date = value.split(this.DELIMITER);
       return {
         year : parseInt(date[0], 10),
         month : parseInt(date[1], 10),
         day : parseInt(date[2], 10)
       };
     }
     return null;
   }
   toModel(date: NgbDateStruct | null): string | null {
     return date ? `${pad(date.year)}${this.DELIMITER}${pad(date.month)}${this.DELIMITER}${pad(date.day)}` : null;
   }
 }